import { defineMessages, FormattedMessage, useIntl } from 'react-intl';

import { Link } from '../../components/Link';
import type { Thread } from '../../types/api';
import { TopicSubject } from './TopicSubject';

const messages = defineMessages({
  topicRemoved: { defaultMessage: "Ce sujet n'existe plus", id: 'NoXxlL' },
  removeWrapper: { defaultMessage: '--- {message} ---', id: 'Zxmhzg' },
  prefixSource: { defaultMessage: 'Sujet source : ', id: '+JnQbX' },
});

/**
 *
 * @param thread
 * @param prefix
 * @param aClassName
 * @param withLink
 * @param shouldIndex
 * @constructor
 */
export const MessageTopic = ({
  thread,
  prefix,
  aClassName,
  withLink,
  shouldIndex,
}: {
  thread: Thread;
  aClassName?: string;
  shouldIndex?: boolean;
  prefix?: boolean;
  withLink?: boolean;
}) => {
  const { topic, url, pageTitle } = thread;
  const { formatMessage } = useIntl();

  if (topic?.status === 'deleted') {
    const message = formatMessage(messages.topicRemoved);
    return (
      <span className={`${aClassName} text-sm`}>
        <FormattedMessage {...messages.removeWrapper} values={{ message }} />
      </span>
    );
  }

  const subject = (
    <div className="subject flex items-center flex-wrap my-1 gap-x-1">
      {prefix && (
        <span className="font-bold uppercase text-xs text-gray-medium font-source tracking-4">
          <FormattedMessage {...messages.prefixSource} />
        </span>
      )}
      <TopicSubject subject={topic?.subject || pageTitle || ''} />
    </div>
  );

  return withLink ? (
    <Link to="topic" params={{ slug: topic?.slug }} disabled={!topic} passHref>
      <a
        className={`${aClassName} hover:text-primary-base`}
        href={url as string}
        rel={shouldIndex ? undefined : 'nofollow'}
      >
        {subject}
      </a>
    </Link>
  ) : (
    subject
  );
};
